import { render, staticRenderFns } from "./Share1.vue?vue&type=template&id=e298b6fa&scoped=true"
import script from "./Share1.vue?vue&type=script&lang=js"
export * from "./Share1.vue?vue&type=script&lang=js"
import style0 from "./Share1.vue?vue&type=style&index=0&id=e298b6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e298b6fa",
  null
  
)

export default component.exports